import React from 'react';

const signals = new Map();

window.NB_SIGNAL_LOG = +(window.localStorage.getItem('NB_SIGNAL_LOG') || 0);;

export const subscribe = (type, handler) => {
  const handlers = signals.get(type);
  handlers ? handlers.push(handler) : signals.set(type, [handler]);
};

export const unsubscribe = (type, handler) => {
  const handlers = signals.get(type);
  handlers && handlers.splice(handlers.indexOf(handler) >>> 0, 1);
};

export const signal = (type, ...args) => {
  if (window.NB_SIGNAL_LOG) console.log('Signal.signal', type, ...args);
  const handlers = signals.get(type);
  handlers && handlers.forEach(handler => handler(...args));
}

export const useSlot = (type, handler) => {
  React.useEffect(() => {
    const wrapper = (...args) => {
      if (window.NB_SIGNAL_LOG) console.log('Signal.slot', type, ...args);
      handler(...args);
    };
    subscribe(type, wrapper);
    return () => unsubscribe(type, wrapper);
  }, [type, handler]);
};

export const useSignal = () => {
  const ref = React.useRef(signal);
  return ref.current;
};

export const useShare = (type, values) => {
  React.useEffect(() => {
    signal(type, values);
  }, [type, values]);
}

export const useMonitor = (type) => {
  const [values, setValues] = React.useState(null);
  const handler = React.useCallback((...args) => {
    setValues(args);
  }, []);
  useSlot(type, handler);
  return values;
}
